import styled from "styled-components";

type ContainerType = {
    background: string;
}

export type TextType = {
    color: string;
    size: number;
}

type BadgeType = {
    background: string;
    color: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 8px;
`;

export const Title = styled.span<TextType>`
  font-size: ${(props) => props.size}px;
  color: ${(props) => props.color};
  font-weight: bold;
  margin: 16px 0 0 0;
`;

export const Content = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: ${props => props.background};
  border-radius: 5px;
  padding: 16px 0;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ItemLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const Text = styled.span<TextType>`
  font-size: ${(props) => props.size}px;
  color: ${(props) => props.color};
`;

export const Badge = styled.span<BadgeType>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
`;
